export default {
  state: {
    pageIndex: 0,
  },
  mutations: {
    changePage(state, index) {
      state.pageIndex = index;
    },
  },
  actions: {},
};
